import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IEvent, IEventListResponse, IEventResponse } from '../models/event';
import config from '../../../../config.js';

@Injectable({
  providedIn: 'root',
})
export class TodoService {
  private apiUrl = `${config.API_GATEWAY_ENDPOINT}/todos`;

  constructor(private http: HttpClient) {}

  getCards(): Observable<IEventListResponse> {
    // `page_size` is the canonical name in the API contract
    // (docs/api/todo_api.yaml). The API also accepts `pageSize` as a legacy
    // alias, so the two repositories can be deployed in either order.
    return this.http.get<IEventListResponse>(this.apiUrl + '?page_size=100');
  }

  deleteCard(id: string) {
    return this.http.delete(this.apiUrl + '/' + id);
  }

  saveCard(card: IEvent): Observable<IEventResponse> {
    const payload = {
      title: card.title,
      description: card.description,
      dueDate: card.dueDate,
    };
    return this.http.post<IEventResponse>(this.apiUrl, payload);
  }

  updateCard(card: IEvent): Observable<IEventResponse> {
    const payload = {
      title: card.title,
      description: card.description,
      dueDate: card.dueDate,
    };
    return this.http.put<IEventResponse>(this.apiUrl + '/' + card.id, payload);
  }
}
